import { render } from "./ExpenseWidget.vue?vue&type=template&id=1d821177&scoped=true"
import script from "./ExpenseWidget.vue?vue&type=script&lang=js"
export * from "./ExpenseWidget.vue?vue&type=script&lang=js"

import "./employee-attendance-widget.scss?vue&type=style&index=0&id=1d821177&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d821177"]])

export default __exports__